import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="pt-28 min-h-screen bg-[#faf6ef] flex items-center">
      <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center py-24">
        <div className="text-[#b4462a] text-xs tracking-[0.3em] uppercase mb-4">404</div>
        <h1 className="font-serif text-6xl md:text-8xl leading-[1.05] tracking-tight font-light mb-6">This thread's gone missing.</h1>
        <p className="text-lg text-[#1a1a1a]/75 max-w-xl mx-auto leading-[1.8] mb-10">The page you were looking for isn't here. Let's weave you somewhere useful.</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/products" className="inline-flex items-center gap-2 bg-[#1e2a5a] text-[#faf6ef] hover:bg-[#b4462a] px-7 py-4 text-xs tracking-[0.25em] uppercase transition" data-testid="404-products">
            Browse products <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
          <Link to="/contact#lead-form" className="inline-flex items-center gap-2 border border-[#1e2a5a] text-[#1e2a5a] hover:bg-[#1e2a5a] hover:text-[#faf6ef] px-7 py-4 text-xs tracking-[0.25em] uppercase transition" data-testid="404-contact">
            Contact us
          </Link>
        </div>
      </div>
    </main>
  );
}
